import { useEffect, useRef, useState } from 'react';

import { Typography } from 'antd';
import { getContrastColor } from '@/pages/Chat/utils';
import MarkdownViewer from '@/components/MarkdownViewer';
import { DownCircleOutlined, EditOutlined } from '@ant-design/icons';

import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from '../Messages.module.scss';

const BreakoutReport = ({ data, onEdit, canEdit }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [maxHeight, setMaxHeight] = useState(0);

  const contentRef = useRef(null);

  useEffect(() => {
    setIsExpanded(false);
  }, [data]);

  useEffect(() => {
    if (contentRef.current) {
      setMaxHeight(isExpanded ? contentRef.current.scrollHeight : 0);
    }
  }, [isExpanded]);

  const toggle = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div
      className={styles['breakout-report__card']}
      style={{ backgroundColor: data.groupColor, color: getContrastColor(data.groupColor) }}
    >
      <div className={styles['breakout-report__header']}>
        <Typography.Title className={styles['breakout-report__title']} level={3}>
          {data.groupName}
        </Typography.Title>
        <div className={styles['breakout-report__actions']}>
          {canEdit && <EditOutlined onClick={() => onEdit(data.content)} size={32} />}
          <DownCircleOutlined
            className={cn(styles['breakout-report__icon'], { [styles['breakout-report__icon_expanded']]: isExpanded })}
            onClick={toggle}
            size={32}
          />
        </div>
      </div>
      <div className={styles['breakout-report__content']} style={{ maxHeight }} ref={contentRef}>
        <MarkdownViewer>{data.content}</MarkdownViewer>
      </div>
    </div>
  );
};

BreakoutReport.propTypes = {
  data: PropTypes.object,
  onEdit: PropTypes.func,
  canEdit: PropTypes.bool,
};

export default BreakoutReport;
